import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 mb-3">
            探索技术分类
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-base">
            八大技术领域，覆盖前端到后端、从 AI 到 DevOps，满足你的全方位学习需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-6 border border-background-200/70 hover:border-primary-300 transition-all duration-300 hover:bg-primary-50/50"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 group-hover:bg-primary-200 transition-colors mb-4">
                <i className={`${cat.icon} text-primary-600 text-xl`}></i>
              </span>
              <h3 className="text-lg font-semibold font-heading text-foreground-900 mb-2 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
                {cat.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{cat.articleCount} 篇文章</span>
                <span className="flex items-center gap-1 text-xs text-primary-600 font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                  浏览 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}